module.exports = __webpack_public_path__ + "img/cyclotruck.cea43b67.png";